import {getMomentDate} from '../utils/commonUtils';
import { CURRENCY } from '../constants/Define';

export default class ExchangeRate {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.sourceCurrency = data.sourceCurrency || CURRENCY.VND;
        this.targetCurrency = data.targetCurrency || undefined;
        this.ratio = data.ratio || undefined;;
        this.createdDate = getMomentDate(data.createdDate);
    }

    export() {
        return {
            id: this.id,
            sourceCurrency: this.sourceCurrency,
            targetCurrency: this.targetCurrency,
            ratio: this.ratio,
        }
    }
}